<template>
	<div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true"
		style="overflow: hidden;">
		<el-row :gutter="20">
			<el-col :span="12">
				<div class="grid-content bg-white">
					<div class="ModularTitle">
						当前轮转人员名单<a style="color:#66b1ff;padding-left: 20px;font-size: 14px;cursor: pointer;"
							@click="JumpToStuScore">[月度绩效考评]</a>
							<!-- <a
							style="color:#66b1ff;padding-left: 20px;font-size: 14px;cursor: pointer;"
							@click="JumpToEvaluation">[延期考评名单]</a> -->
					</div>
					<div style="padding: 25px;height: 218px;overflow: auto;">
						<el-table :data="tableINCP" stripe style="width: 100%" size="medium" v-loading="loading">
							<el-table-column prop="StuName" label="姓名">
							</el-table-column>
							<el-table-column prop="StuNo" label="工号">
							</el-table-column>
							<el-table-column prop="CPSecName" label="轮转科室">
							</el-table-column>
							<el-table-column label="轮转时间" width="240">
								<template slot-scope="scope">
									{{scope.row.CPBeginDate|formatFullDate}} 至 {{scope.row.CPEndDate|formatFullDate}}
								</template>
							</el-table-column>
							<!-- <el-table-column label="操作">
								<template slot-scope="scope">
									<span v-if="scope.row.Delay==0" style="color: #666;">延期审核中</span>
									<span v-else-if="scope.row.Delay==1" style="color: green;">已延期</span>
									<span v-else-if="scope.row.Delay==2" style="color: red;">延期退回</span>
									<el-button type="text" size="medium" @click="delayEvaluation(scope.row)" v-else>延期考评
									</el-button>
								</template>
							</el-table-column> -->
						</el-table>
					</div>
				</div>
			</el-col>
			<el-col :span="12">
				<div class="grid-content bg-white">
					<div class="ModularTitle">
						即将入科人员名单<a style="color:#66b1ff;padding-left: 20px;font-size: 14px;cursor: pointer;"
							@click="JumpToEntry">[入科管理]</a>
					</div>
					<div style="padding: 25px;height: 218px;overflow: auto;">
						<el-table :data="tableUnINCP" stripe style="width: 100%" size="medium" v-loading="loading">
							<el-table-column prop="CPStuName" label="姓名">
							</el-table-column>
							<el-table-column prop="CPStuNo" label="工号">
							</el-table-column>
							<el-table-column prop="SecName" label="轮转科室">
							</el-table-column>
							<el-table-column label="轮转时间" width="240">
								<template slot-scope="scope">
									{{scope.row.CPBeginDate|formatFullDate}} 至 {{scope.row.CPEndDate|formatFullDate}}
								</template>
							</el-table-column>
							<!-- <el-table-column label="入科" width="150">
                <template slot-scope="scope">
                  <el-upload class="upload-demo" ref="upload" :action='uploadUrl' :data="{id:scope.row.CPID}" :limit="1"
                    :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess" :show-file-list="false">
                    <a style="color:#66b1ff">[上传]</a>
                  </el-upload>
                </template>
              </el-table-column> -->
						</el-table>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="20" style="padding-top: 24px;">
			<el-col :span="24">
				<div class="grid-content bg-white">
					<div class="ModularTitle">
						带教老师名单<a style="color:#66b1ff;padding-left: 20px;font-size: 14px;cursor: pointer;"
							@click="JumpToTecScore">[月度绩效考评]</a>
					</div>
					<div style="padding: 25px;height: 218px;overflow: auto;">
						<el-table :data="tableTec" stripe style="width: 100%" size="medium" v-loading="loading">
							<el-table-column prop="TrueName" label="姓名">
							</el-table-column>
							<el-table-column prop="CardNo" label="工号">
							</el-table-column>
							<el-table-column prop="CurrentCount" label="现带教人数">
							</el-table-column>
							<el-table-column prop="TotalCount" label="总带教人数">
							</el-table-column>
						</el-table>
					</div>
				</div>
			</el-col>
		</el-row>

		<el-dialog title="添加延期考评" :visible.sync="dialogDelayVisible" width="500px">
			<el-form :model="form">
				<el-form-item label="姓名" label-width="120px">
					<el-input v-model="form.delay.stuName" autocomplete="off" readonly></el-input>
				</el-form-item>
				<el-form-item label="工号" label-width="120px">
					<el-input v-model="form.delay.stuNo" autocomplete="off" readonly></el-input>
				</el-form-item>
				<el-form-item label="延期月份" label-width="120px">
					<el-input v-model="form.delay.delayMonth" autocomplete="off" readonly></el-input>
				</el-form-item>
				<el-form-item label="延期理由" label-width="120px">
					<el-input v-model="form.delay.reason" autocomplete="off" type="textarea" :rows="3"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogDelayVisible = false">取 消</el-button>
				<el-button type="primary" @click="delaySave">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'IndexSection',
		data() {
			return {
				condition: {
					username: '',
					rolelevel: '',
					secid: '',
					token: '',
					manageid: ''
				},
				tableINCP: null,
				tableUnINCP: null,
				tableTec: null,
				uploadUrl: this.$utils.Url.zpgl + '/api/APICyclePlan/UploadEnterFile',
				loading: true,
				dialogDelayVisible: false,
				form: {
					delay: {
						token: '',
						cpid: '', //轮转明细编号
						cpSec: '', //管理单元编号
						cpSecName: '', //管理单元名称
						stuid: '', //学生编号
						stuName: '', //学生姓名
						stuNo: '', //学生工号
						reason: '', //理由
						delayMonth: '', //延期日期
						dataStatus: 0 //状态
					}
				}
			}
		},
		filters: {
			formatFullDate(val) {
				var now = new Date(val)
				var y = now.getFullYear()
				var m = now.getMonth() + 1
				var d = now.getDate()
				return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
			}
		},
		methods: {
			JumpToStuScore: function() {
				this.$router.push('/main/achievement/stu/score')
			},
			JumpToTecScore: function() {
				this.$router.push('/main/achievement/teach/score')
			},
			JumpToEntry: function() {
				this.$router.push('/main/cycle/entry/list')
			},
			JumpToEvaluation: function() {
				this.$router.push('/main/cycle/evaluation/list')
			},
			LoadINCP: function() {
				this.loading = true
				this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/IndexSectionINCP', this.condition)
					.then(res => {
						console.log(res.data)
						if (res.data.Code === 0) {
							this.tableINCP = res.data.Data
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						this.loading = false
					})
					.catch(err => {
						this.tableINCP = null
						console.log(err)
						this.$message({
							message: '查询失败',
							type: 'error'
						})
						this.loading = false
					})
			},
			LoadUnINCP: function() {
				this.loading = true
				this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/IndexSectionUnINCP', this.condition)
					.then(res => {
						if (res.data.Code === 0) {
							this.tableUnINCP = res.data.Data
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						this.loading = false
					})
					.catch(err => {
						this.tableUnINCP = null
						console.log(err)
						this.$message({
							message: '查询失败',
							type: 'error'
						})
						this.loading = false
					})
			},
			LoadTec: function() {
				this.loading = true
				this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/IndexSectionTec', this.condition)
					.then(res => {
						if (res.data.Code === 0) {
							this.tableTec = res.data.Data
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						this.loading = false
					})
					.catch(err => {
						this.tableTec = null
						console.log(err)
						this.$message({
							message: '查询失败',
							type: 'error'
						})
						this.loading = false
					})
			},
			beforeAvatarUpload: function(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
				}
				return isJPG
			},
			handleAvatarSuccess: function(res) {
				if (res.Code === 0) {
					this.$message({
						message: '上传成功',
						type: 'success'
					})
					this.LoadUnINCP()
				} else {
					this.$message({
						message: res.Msg + '，' + res.Error,
						type: 'error'
					})
				}
			},
			delayEvaluation: function(row) {
				this.dialogDelayVisible = true
				this.form.delay.adduid = sessionStorage.getItem('userid')
				this.form.delay.cpid = row.ID
				this.form.delay.cpSec = row.CPSec
				this.form.delay.cpSecName = row.CPSecName
				this.form.delay.stuid = row.StuID
				this.form.delay.stuName = row.StuName
				this.form.delay.stuNo = row.StuNo
				this.form.delay.delayMonth = new Date(row.CPBeginDate.replace('T', ' ')).getFullYear() + '年' + (
					new Date(row.CPBeginDate.replace('T', ' ')).getMonth() + 1) + '月'

			},
			//保存延期数据
			delaySave: function() {
				var that = this
				if (that.form.delay.reason == '') {
					that.$message({
						message: '延期理由不能为空',
						type: 'error'
					})
					return
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/AddDelayEvaluation', this.form.delay)
					.then(res => {
						if (res.data.Code === 0) {
							//重新加载列表
							that.LoadINCP()
							that.dialogDelayVisible = false
							that.$message({
								message: '保存成功',
								type: 'success'
							})
						} else {
							that.$message({
								message: res.data.Msg + '，' + res.data.Data,
								type: 'error'
							})
						}
						that.fullscreenLoading = false
					})
					.catch(err => {
						console.log(err)
						that.$message({
							message: '保存失败',
							type: 'error'
						})
						that.fullscreenLoading = false
					})
			},
			
		},
		mounted: function() {
			this.form.delay.token = sessionStorage.getItem('token')
			this.condition.token = sessionStorage.getItem('token')
			this.condition.username = sessionStorage.getItem('username')
			this.condition.rolelevel = sessionStorage.getItem('rolelevel')
			this.condition.secid = sessionStorage.getItem('secid')
			this.condition.manageid = sessionStorage.getItem('manageid')
			this.LoadINCP()
			this.LoadUnINCP()
			this.LoadTec()
		}
	}
</script>

<style scoped="scoped">
	.ModularTitle {
		width: 100%;
		height: 50px;
		line-height: 50px;
		margin-left: 20px;
		font-size: 18px;
	}

	.ModularNumber {
		width: 100%;
		height: 50px;
		line-height: 50px;
		font-size: 35px;
		color: #FFFFFF;
		text-align: center;
	}

	.ModularName {
		width: 100%;
		height: 30px;
		line-height: 30px;
		font-size: 12px;
		color: #FFFFFF;
		text-align: center;
	}

	.ModularTecNumber {
		width: 100%;
		height: 80px;
		line-height: 80px;
		font-size: 35px;
		color: #FFFFFF;
		text-align: center;
	}

	.grid-content {
		border-radius: 5px;
	}
</style>
